import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const TexasAMUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Texas A&M University"
      universityShortName="Texas A&M"
      slug="texas-am-university"
      seoTitle="Texas A&M Study Rooms | College Station Library Study Spaces"
      seoDescription="Find study rooms at Texas A&M including Evans Library and West Campus Library. Learn booking policies, quiet zones, and discover CSW as an online alternative."
      seoKeywords="Texas A&M study rooms, TAMU library, Evans Library study rooms, College Station study spaces, Aggie study rooms"
      canonicalUrl="/study-room/texas-am-university/"
      heroDescription="Explore Texas A&M's group and individual study rooms with clear quiet and collaborative zones."
      libraryWebsiteUrl="https://library.tamu.edu"
      libraryWebsiteName="Texas A&M Libraries"
      studySpaces={[
        {
          name: "Evans Library - Group Rooms",
          features: "Reserve up to 4 hours/day, 1 week in advance. Whiteboards and monitors available.",
          feedback: "Common floors can be noisy. Upper silent floors offer better focus."
        },
        {
          name: "Evans Library - Individual Rooms",
          features: "Silent solo study, up to 8 hours/day. Some first-come, first-served.",
          feedback: "Great for deep focus. Check in within 15 minutes required."
        },
        {
          name: "West Campus Library",
          features: "Group rooms with large monitors, collaborative environment.",
          feedback: "Best for group projects and presentations. Modern facilities."
        },
        {
          name: "Annex Individual Rooms",
          features: "Quiet individual study spaces, extended reservation times.",
          feedback: "Perfect for dissertation work and intensive studying."
        }
      ]}
      guideContent={
        <>
          <p>
            Texas A&M Libraries provide two types of study rooms: group rooms for two or more students and 
            individual quiet rooms. Group rooms can be reserved up to a week in advance for four hours per day.
          </p>
          <p className="mt-4">
            Individual rooms are for silent solo study and may be reserved for up to eight hours per day. 
            All users must check in within 15 minutes; leaving a room unattended for more than 15 minutes voids the reservation.
          </p>
          <p className="mt-4">
            Choose your environment: collaborative work is best at the West Campus Library's group rooms with large monitors. 
            For deep focus, head to the upper silent floors of Evans or the Annex's individual study rooms.
          </p>
        </>
      }
      summaryTips={[
        "Book group rooms up to 1 week in advance",
        "Individual rooms allow up to 8 hours/day",
        "Check in within 15 minutes to keep your reservation",
        "West Campus Library has the best tech for group work",
        "Bring headphones for the common floors"
      ]}
    />
  );
};

export default TexasAMUniversity;
